(function () {
  "use strict";

  // --------------------------------------------------------------------
  // Ce fichier est désormais la seule couche "données / logique métier" du
  // module Thème astral : formulaire, appel à l'API de calcul (backend),
  // export PDF et envoi de l'email de résultat. Il ne contient plus AUCUN
  // code de rendu (roue, cartes, tooltips) — l'affichage du résultat est
  // entièrement délégué au composant indépendant ThemeAstralPremium
  // (voir assets/theme-astral-premium.js), qui reçoit ici les données brutes
  // renvoyées par le backend (chart.planets / ascendant / midheaven / houses /
  // aspects) sans qu'aucun calcul astrologique ne soit modifié.
  // --------------------------------------------------------------------

  var ASTRO_KLAVIYO = { company: "SEHdjk", listId: "XKNEyg", metric: "Thème astral révélé" };

  // --------------------------------------------------------------------
  // PDF (html2canvas-pro + jsPDF, chargés à la demande, comme sur /numerologie)
  // NOTE: on utilise html2canvas-pro (fork compatible CSS Color 4 : oklch,
  // lab, lch, color-mix...) au lieu de html2canvas 1.4.1, qui plante avec
  // l'erreur "Attempting to parse an unsupported color function 'oklch'"
  // dès que le navigateur expose une couleur calculée dans ce format.
  // --------------------------------------------------------------------

  function loadScriptOnce(src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-astro-lib="' + src + '"]');
      if (existing) {
        if (existing.getAttribute("data-loaded") === "true") return resolve();
        existing.addEventListener("load", function () { resolve(); });
        existing.addEventListener("error", reject);
        return;
      }
      var s = document.createElement("script");
      s.src = src;
      s.setAttribute("data-astro-lib", src);
      s.onload = function () {
        s.setAttribute("data-loaded", "true");
        resolve();
      };
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  // --------------------------------------------------------------------
  // Dépliage/repliage temporaire de tous les accordéons ("dossiers") du
  // thème (Significations et ses 6 sous-menus, Interprétation et ses 10
  // chapitres, Synthèse globale) : le PDF exporté doit montrer le thème
  // COMPLET, pas seulement les titres repliés visibles à l'écran. On
  // mémorise l'état initial de chaque <details> pour le restaurer une fois
  // le PDF généré, afin de ne pas perturber la vue interactive de
  // l'utilisateur.
  // --------------------------------------------------------------------

  function expandAllDetails(container) {
    var previouslyClosed = [];
    container.querySelectorAll("details").forEach(function (d) {
      if (!d.open) {
        previouslyClosed.push(d);
        d.open = true;
      }
    });
    return previouslyClosed;
  }

  function collapseDetails(previouslyClosed) {
    previouslyClosed.forEach(function (d) { d.open = false; });
  }

  // --------------------------------------------------------------------
  // Le thème astral utilise des animations CSS de fondu/translation à
  // l'apparition (@keyframes tapFadeUp / tapFadeIn, voir
  // theme-astral-premium.css) sur la quasi-totalité de ses blocs. Comme
  // html2canvas-pro peut mettre plusieurs centaines de millisecondes à
  // parcourir un thème complet (une fois tous les accordéons dépliés), la
  // capture se retrouvait "à cheval" sur ces animations encore en cours :
  // le haut du document (traité en premier par html2canvas) apparaissait
  // capturé tôt dans l'animation (quasi invisible, opacity proche de 0)
  // tandis que le bas apparaissait capturé plus tard (presque normal) —
  // d'où un PDF quasi illisible en haut de page et correct en bas.
  // On neutralise donc toutes les animations en cours juste avant la
  // capture (elles retombent alors sur leur état final normal, sans
  // toucher aux opacités "normales" définies hors animation comme celles
  // des tooltips ou des maisons du zodiaque), puis on les restaure après.
  // --------------------------------------------------------------------

  function freezeAnimations(container) {
    var frozen = [];
    function freezeOne(el) {
      if (getComputedStyle(el).animationName !== "none") {
        frozen.push({ el: el, prev: el.style.animation });
        el.style.animation = "none";
      }
    }
    freezeOne(container);
    container.querySelectorAll("*").forEach(freezeOne);
    return frozen;
  }

  function unfreezeAnimations(frozen) {
    frozen.forEach(function (entry) {
      entry.el.style.animation = entry.prev;
    });
  }

  function downloadAstroPDF(container, payload) {
    return loadScriptOnce("https://cdn.jsdelivr.net/npm/html2canvas-pro@2.0.4/dist/html2canvas-pro.min.js")
      .then(function () {
        return loadScriptOnce("https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js");
      })
      .then(function () {
        return window.html2canvas(container, { scale: 2, backgroundColor: "#faf8f5" });
      })
      .then(function (canvas) {
        var jsPDFCtor = window.jspdf && window.jspdf.jsPDF;
        if (!jsPDFCtor) throw new Error("jsPDF indisponible");
        var pdf = new jsPDFCtor("p", "mm", "a4");
        var pageWidth = pdf.internal.pageSize.getWidth();
        var pageHeight = pdf.internal.pageSize.getHeight();
        var imgWidth = pageWidth;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var heightLeft = imgHeight;
        var position = 0;
        // JPEG plutôt que PNG : sur un thème complet déplié (très grande
        // hauteur, donc un canvas à scale:2 pouvant dépasser plusieurs
        // dizaines de milliers de pixels de haut), un PNG non compressé
        // produisait des PDF de plus de 150 Mo, quasi impossibles à
        // télécharger ou ouvrir. Le JPEG à qualité 0.92 est visuellement
        // quasi identique pour ce contenu (texte + aplats de couleur) et
        // réduit le poids du fichier d'un facteur 20 à 50.
        var imgData = canvas.toDataURL("image/jpeg", 0.92);

        pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
        while (heightLeft > 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        var safeName = (payload.firstName || "theme").toLowerCase().replace(/[^a-z0-9]+/g, "-");
        pdf.save("theme-astral-" + safeName + "-" + (payload.birthDate || "") + ".pdf");
      });
  }

  // --------------------------------------------------------------------
  // "Recevoir par email" — même schéma que /numerologie : appel direct
  // au Client API Klaviyo (clé publique, pas de secret exposé). Un Flow
  // Klaviyo déclenché par la metric ASTRO_KLAVIYO.metric doit être créé
  // côté Klaviyo pour l'envoi effectif de l'email.
  // --------------------------------------------------------------------

  function sendAstroEmailEvent(payload, contentHtml) {
    var profilePayload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: { email: payload.email, first_name: payload.firstName, last_name: payload.lastName }
            }
          }
        },
        relationships: {
          list: { data: { type: "list", id: ASTRO_KLAVIYO.listId } }
        }
      }
    };

    // "chart_content_html" transporte le thème complet (roue reconstruite en
    // HTML/CSS statique + toutes les sections Significations + les 10
    // chapitres d'Interprétation + la Synthèse globale), déjà entièrement
    // généré côté client par ThemeAstralPremium.buildEmailHtml — le Flow
    // Klaviyo n'a plus qu'à l'insérer tel quel dans le template email
    // (propriété d'événement {{ event.chart_content_html }}).
    var eventPayload = {
      data: {
        type: "event",
        attributes: {
          properties: {
            birthDate: payload.birthDate,
            birthPlace: payload.birthPlace,
            firstName: payload.firstName,
            lastName: payload.lastName,
            chart_content_html: contentHtml || ""
          },
          metric: { data: { type: "metric", attributes: { name: ASTRO_KLAVIYO.metric } } },
          profile: { data: { type: "profile", attributes: { email: payload.email } } }
        }
      }
    };

    return Promise.allSettled([
      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + ASTRO_KLAVIYO.company, {
        method: "POST",
        headers: { "Content-Type": "application/json", revision: "2024-10-15" },
        body: JSON.stringify(profilePayload)
      }),
      fetch("https://a.klaviyo.com/client/events/?company_id=" + ASTRO_KLAVIYO.company, {
        method: "POST",
        headers: { "Content-Type": "application/json", revision: "2024-10-15" },
        body: JSON.stringify(eventPayload)
      })
    ]);
  }

  function initAstroForm(root) {
    var form = root.querySelector(".spiritum-astro__form");
    var message = root.querySelector(".spiritum-astro__message");
    var submitBtn = root.querySelector(".spiritum-astro__submit");
    var resultsContainer = root.querySelector('[data-role="astro-results"]');
    var endpoint = root.getAttribute("data-endpoint");
    var shop = root.getAttribute("data-shop");
    var placesEndpoint = endpoint
      ? endpoint.replace(/\/api\/generate-chart\/?$/, "/api/places-search")
      : null;
    var lastPayload = null;
    // Réponse brute du backend (contient body.chart) — nécessaire pour
    // reconstruire le contenu complet du thème au moment de l'envoi par
    // email (voir ThemeAstralPremium.buildEmailHtml), en plus de lastPayload
    // qui ne contient que les champs du formulaire.
    var lastChartData = null;

    if (!endpoint) {
      console.warn(
        "[Spiritum Astro] Aucune URL d'API configurée dans les réglages du bloc de section."
      );
    }

    function setMessage(text, state) {
      message.textContent = text || "";
      if (state) {
        message.setAttribute("data-state", state);
      } else {
        message.removeAttribute("data-state");
      }
    }

    function setFieldInvalid(field, invalid) {
      var wrapper = field.closest(".spiritum-astro__field");
      if (wrapper) {
        wrapper.setAttribute("data-invalid", invalid ? "true" : "false");
      }
    }

    // --- Date / heure de naissance : combinaison des sélecteurs jour/mois/année, heure/minute ---
    var dayEl = form.querySelector('[data-role="birth-day"]');
    var monthEl = form.querySelector('[data-role="birth-month"]');
    var yearEl = form.querySelector('[data-role="birth-year"]');
    var hourEl = form.querySelector('[data-role="birth-hour"]');
    var minuteEl = form.querySelector('[data-role="birth-minute"]');
    var birthDateHidden = form.querySelector('input[name="birthDate"]');
    var birthTimeHidden = form.querySelector('input[name="birthTime"]');

    function syncBirthDate() {
      if (dayEl.value && monthEl.value && yearEl.value) {
        birthDateHidden.value = yearEl.value + "-" + monthEl.value + "-" + dayEl.value;
      } else {
        birthDateHidden.value = "";
      }
    }

    function syncBirthTime() {
      if (hourEl.value && minuteEl.value) {
        birthTimeHidden.value = hourEl.value + ":" + minuteEl.value;
      } else {
        birthTimeHidden.value = "";
      }
    }

    [dayEl, monthEl, yearEl].forEach(function (el) {
      el.addEventListener("change", syncBirthDate);
    });
    [hourEl, minuteEl].forEach(function (el) {
      el.addEventListener("change", syncBirthTime);
    });

    // --- Autocomplete ville/pays pour le lieu de naissance ---
    var placeInput = form.querySelector('[data-role="place-input"]');
    var placeLat = form.querySelector('[data-role="place-lat"]');
    var placeLon = form.querySelector('[data-role="place-lon"]');
    var suggestionsList = form.querySelector('[data-role="place-suggestions"]');
    var debounceTimer = null;
    var activeIndex = -1;
    var currentResults = [];

    function clearSuggestions() {
      suggestionsList.innerHTML = "";
      suggestionsList.hidden = true;
      activeIndex = -1;
      currentResults = [];
    }

    function updateActiveItem(items) {
      items.forEach(function (item, index) {
        item.classList.toggle("is-active", index === activeIndex);
      });
    }

    function selectPlace(place) {
      placeInput.value = place.displayName;
      placeLat.value = place.latitude;
      placeLon.value = place.longitude;
      setFieldInvalid(placeInput, false);
      clearSuggestions();
    }

    function renderSuggestions(results) {
      currentResults = results;
      suggestionsList.innerHTML = "";
      if (!results.length) {
        suggestionsList.hidden = true;
        return;
      }
      results.forEach(function (place, index) {
        var li = document.createElement("li");
        li.setAttribute("role", "option");
        li.setAttribute("data-index", index);
        li.textContent = place.displayName;
        li.addEventListener("mousedown", function (event) {
          event.preventDefault();
          selectPlace(place);
        });
        suggestionsList.appendChild(li);
      });
      suggestionsList.hidden = false;
    }

    placeInput.addEventListener("input", function () {
      // L'utilisateur modifie le texte : on invalide la sélection précise précédente.
      // Si aucune nouvelle suggestion n'est choisie, le backend retombera sur un
      // géocodage classique à partir du texte saisi.
      placeLat.value = "";
      placeLon.value = "";

      var query = placeInput.value.trim();
      if (debounceTimer) clearTimeout(debounceTimer);

      if (!placesEndpoint || query.length < 3) {
        clearSuggestions();
        return;
      }

      debounceTimer = setTimeout(function () {
        fetch(placesEndpoint + "?q=" + encodeURIComponent(query))
          .then(function (res) {
            if (!res.ok) throw new Error("places-search failed");
            return res.json();
          })
          .then(function (body) {
            renderSuggestions((body && body.results) || []);
          })
          .catch(function () {
            clearSuggestions();
          });
      }, 400);
    });

    placeInput.addEventListener("keydown", function (event) {
      if (suggestionsList.hidden || !currentResults.length) return;
      var items = suggestionsList.querySelectorAll("li");
      if (event.key === "ArrowDown") {
        event.preventDefault();
        activeIndex = Math.min(activeIndex + 1, items.length - 1);
        updateActiveItem(items);
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        activeIndex = Math.max(activeIndex - 1, 0);
        updateActiveItem(items);
      } else if (event.key === "Enter") {
        if (activeIndex >= 0 && currentResults[activeIndex]) {
          event.preventDefault();
          selectPlace(currentResults[activeIndex]);
        }
      } else if (event.key === "Escape") {
        clearSuggestions();
      }
    });

    placeInput.addEventListener("blur", function () {
      // Laisse le temps au mousedown d'une suggestion de s'exécuter avant de fermer la liste.
      setTimeout(clearSuggestions, 150);
    });

    function validate(data) {
      var errors = [];
      ["firstName", "lastName", "birthDate", "birthTime", "birthPlace", "email"].forEach(
        function (key) {
          var field = form.querySelector('[name="' + key + '"]');
          var invalid = !data[key] || !String(data[key]).trim();
          setFieldInvalid(field, invalid);
          if (invalid) errors.push(key);
        }
      );

      var emailField = form.querySelector('[name="email"]');
      if (data.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
        setFieldInvalid(emailField, true);
        errors.push("email");
      }

      if (!data.consent) {
        errors.push("consent");
      }

      return errors;
    }

    // --- Actions sur les résultats (email / PDF / retour) ---
    if (resultsContainer) {
      resultsContainer.addEventListener("click", function (event) {
        var target = event.target.closest("[data-action]");
        if (!target) return;
        var action = target.getAttribute("data-action");

        if (action === "astro-back") {
          resultsContainer.hidden = true;
          resultsContainer.innerHTML = "";
          form.hidden = false;
          form.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }

        if (action === "astro-pdf") {
          var originalLabel = target.textContent;
          target.disabled = true;
          target.textContent = "Génération…";

          // Le PDF doit montrer le thème COMPLET : on déplie temporairement
          // tous les accordéons (Significations + 6 sous-menus,
          // Interprétation + 10 chapitres, Synthèse globale) et on masque
          // cette barre d'actions (qui n'a pas vocation à apparaître dans le
          // document exporté), puis on restaure l'état initial une fois
          // terminé — la vue interactive de l'utilisateur n'est pas altérée.
          var reClosed = expandAllDetails(resultsContainer);
          var actionsBar = resultsContainer.querySelector(".tap-actions");
          if (actionsBar) actionsBar.hidden = true;

          // On neutralise aussi les animations d'apparition (fondu) encore
          // en cours, sans quoi la capture peut geler le contenu à mi-fondu
          // par endroits — voir le commentaire sur freezeAnimations().
          var frozen = freezeAnimations(resultsContainer);

          // Court délai avant la capture : laisse le temps à la mise en page
          // de se stabiliser après le dépliage des accordéons (reflow),
          // les animations elles-mêmes étant déjà neutralisées ci-dessus.
          new Promise(function (resolve) { setTimeout(resolve, 400); })
            .then(function () {
              return downloadAstroPDF(resultsContainer, lastPayload || {});
            })
            .catch(function () {
              setMessage("Le téléchargement du PDF a échoué. Merci de réessayer.", "error");
            })
            .finally(function () {
              unfreezeAnimations(frozen);
              collapseDetails(reClosed);
              if (actionsBar) actionsBar.hidden = false;
              target.disabled = false;
              target.textContent = originalLabel;
            });
          return;
        }

        if (action === "astro-email") {
          var original = target.textContent;
          target.disabled = true;
          target.textContent = "Envoi…";

          // Reconstruit le thème complet (roue statique + toutes les
          // sections + les 10 chapitres + synthèse) pour l'inclure dans
          // l'événement Klaviyo — voir ThemeAstralPremium.buildEmailHtml.
          // Si la génération échoue pour une raison quelconque, on envoie
          // quand même l'événement (sans le contenu complet) plutôt que de
          // bloquer l'action de l'utilisateur.
          var contentHtml = "";
          try {
            if (window.ThemeAstralPremium && typeof window.ThemeAstralPremium.buildEmailHtml === "function") {
              contentHtml = window.ThemeAstralPremium.buildEmailHtml(lastChartData || {}, lastPayload || {});
            }
          } catch (e) {
            console.error("[Spiritum Astro] Échec de la génération du contenu email complet :", e);
          }

          sendAstroEmailEvent(lastPayload || {}, contentHtml).finally(function () {
            target.textContent = "Envoyé ✓";
            setTimeout(function () {
              target.textContent = original;
              target.disabled = false;
            }, 3000);
          });
        }
      });
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      setMessage("", null);

      // S'assurer que les valeurs combinées sont à jour même sans événement "change"
      // sur le dernier sélecteur modifié juste avant la soumission.
      syncBirthDate();
      syncBirthTime();

      var formData = new FormData(form);
      var lat = formData.get("birthLatitude");
      var lon = formData.get("birthLongitude");
      var payload = {
        firstName: formData.get("firstName"),
        lastName: formData.get("lastName"),
        birthDate: formData.get("birthDate"),
        birthTime: formData.get("birthTime"),
        birthPlace: formData.get("birthPlace"),
        email: formData.get("email"),
        consent: formData.get("consent") === "on",
        shop: shop,
        source: "shopify-theme-astral-block"
      };
      if (lat && lon) {
        payload.latitude = parseFloat(lat);
        payload.longitude = parseFloat(lon);
      }

      var errors = validate(payload);
      if (errors.length) {
        setMessage(
          "Merci de compléter tous les champs obligatoires et d'accepter les conditions.",
          "error"
        );
        return;
      }

      if (!endpoint) {
        setMessage(
          "Le formulaire n'est pas encore relié à l'API de calcul. Contactez l'administrateur du site.",
          "error"
        );
        return;
      }

      submitBtn.disabled = true;
      setMessage("Calcul de votre thème astral en cours…", null);

      fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (body) {
              throw new Error(body && body.error ? body.error : "Erreur serveur");
            });
          }
          return response.json();
        })
        .then(function (body) {
          lastPayload = payload;
          lastChartData = body;
          if (resultsContainer && body && body.chart) {
            // Rendu entièrement délégué au composant indépendant
            // ThemeAstralPremium — ce fichier ne fait plus que transmettre
            // les données brutes reçues du backend (aucun calcul ici).
            if (window.ThemeAstralPremium && typeof window.ThemeAstralPremium.render === "function") {
              window.ThemeAstralPremium.render(resultsContainer, body, payload);
            } else {
              resultsContainer.innerHTML = "<p>Le module d'affichage du thème astral n'a pas pu être chargé.</p>";
              console.error("[Spiritum Astro] window.ThemeAstralPremium introuvable — vérifiez que theme-astral-premium.js est bien chargé.");
            }
            resultsContainer.hidden = false;
            form.hidden = true;
            clearSuggestions();
            setMessage("", null);
            resultsContainer.scrollIntoView({ behavior: "smooth", block: "start" });
          } else {
            setMessage(
              "Votre thème astral est en route ! Vérifiez votre boîte email (et vos spams) dans quelques minutes.",
              "success"
            );
            form.reset();
            clearSuggestions();
            placeLat.value = "";
            placeLon.value = "";
          }
        })
        .catch(function (err) {
          setMessage(
            "Une erreur est survenue : " + err.message + ". Merci de réessayer.",
            "error"
          );
        })
        .finally(function () {
          submitBtn.disabled = false;
        });
    });

    // --------------------------------------------------------------------
    // Mode démo (lien direct) : si l'URL de la page contient ?astro_demo=1,
    // on pré-remplit le formulaire avec un jeu de données fourni par
    // l'équipe Spiritum (Jonathan Dufour, né le 19/07/1991 à 16h30 à
    // Marcq-en-Barœul) et on soumet automatiquement, pour pouvoir partager
    // un lien qui affiche directement ce thème sans ressaisir les
    // informations à chaque fois.
    // --------------------------------------------------------------------
    (function maybeRunDemo() {
      var params;
      try {
        params = new URLSearchParams(window.location.search);
      } catch (e) {
        return;
      }
      if (!params.get("astro_demo")) return;

      var firstNameEl = form.querySelector('[name="firstName"]');
      var lastNameEl = form.querySelector('[name="lastName"]');
      var emailEl = form.querySelector('[name="email"]');
      var consentEl = form.querySelector('[name="consent"]');

      if (firstNameEl) firstNameEl.value = "Jonathan";
      if (lastNameEl) lastNameEl.value = "Dufour";
      if (dayEl) dayEl.value = "19";
      if (monthEl) monthEl.value = "07";
      if (yearEl) yearEl.value = "1991";
      if (hourEl) hourEl.value = "16";
      if (minuteEl) minuteEl.value = "30";
      syncBirthDate();
      syncBirthTime();
      placeInput.value = "Marcq-en-Baroœul, Lille, Nord, Hauts-de-France, France métropolitaine, 59700, France";
      placeLat.value = "50.671101";
      placeLon.value = "3.097200";
      if (emailEl) emailEl.value = "jonathandufour.fr@gmail.com";
      if (consentEl) consentEl.checked = true;

      setTimeout(function () {
        if (typeof form.requestSubmit === "function") form.requestSubmit();
        else form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
      }, 50);
    })();
  }

  document.querySelectorAll(".spiritum-astro").forEach(initAstroForm);
})();